/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of consultss (patients) to display or load consultss */


(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultlist', {
      restrict: 'E',
      bindings: {
        consults: '<?',
        patientid: '<?'
      },
      templateUrl: 'vcconsult/consultlist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Consult', 'ConsultHelper', 'vertxEventBusService', '$q',
        function ($log, $http, Rlog, Consult, ConsultsHelper, vertxEventBusService, $q) {
          let vm = this;
          vm.editConsult = ConsultsHelper.editConsult;
          vm.removeConsult = removeConsult;
          vm.togglePanel = togglePanel;
          vm.$log = $log;

/*
          vm.$onInit = function () {
            vm.display = [];
            // unless vcclient list has been passed for test purposes, retrieve vcconsult list from web
            if (angular.isUndefined(vm.consults) && angular.isUndefined(vm.patientid)) {
              vm.consults = Consult.$search();
            }

            if (angular.isUndefined(vm.consults) && angular.isDefined(vm.patientid)) {
              vm.consults = Consult.$searchBy('patientid', vm.patientid);
            }
          }; // $onInit()
*/


          vm.$onChanges = function (changes) {
            vm.display = [];

            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
              Consult.$searchBy('patientid', vm.patientid).$then(function(consults) {
                vm.consults = consults;
                vm.numCC = numFinishedConsults(consults);
              });
            }
          }; // $onInit()


          function numFinishedConsults(consults) {
            let fc = consults.filter(function (e) {
              return !e.open;
            });
            return fc.length;
          }


          function removeConsult(consult) {
            consult.active = false;
            consult.$save();
          }

          function togglePanel(i, cons) {
            if (angular.isUndefined(vm.display[i]) || vm.display[i] === false) {
              $q.all(pullDetails(cons)).then(function () {
                $log.debug('debug - documents: ', cons.documents);
                vm.display[i] = true;
              });
            } else {
              // TODO: figure out how to destroy content of individual consults on hide
              // delete cons.documents;
              // delete cons.files;
              // delete cons.examinations;
              vm.display[i] = false;
            }
          }

          function pullDetails(cons) {
            let chain = [];
            chain.push(cons.examinations.$refresh().$asPromise());
            chain.push(cons.documents.$refresh().$asPromise());
            // chain.push(cons.files.$refresh().$asPromise());
            return chain;
          }


          vertxEventBusService.on('consults.update', function (message) {
            $log.debug('debug: consults update received: ', message);
            vm.consults.$refresh().$then(function () {
              $log.debug('debug: consultlist refreshed consults');
            }, function (error) {
              $log.debug('debug: consultlist refresh consults failed: ', error);
            });
          });

        }] // controller
    }); // component

  // klammerfriedhof
}());
